/* eslint-disable react-refresh/only-export-components */
import { useDateFormat } from "@/hooks/use-date-format";
import { formatDate, formatRelative } from "@/lib/dates";

/** "31 de octubre de 2026" in the given app locale. */
export const formatLocalizedDate = (date: string, locale = "es") =>
  formatDate(date, locale, {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

/**
 * "hoy a las 13:05" within a week, "31 oct 2026" beyond. See
 * `formatRelative` in `@/lib/dates`.
 */
export const formatRelativeDate = (date: string, locale = "es") =>
  formatRelative(date, locale);

export const useRelativeDate = (date: string) =>
  useDateFormat().formatRelative(date);

export function RelativeDate({ date }: { date: string }) {
  return useRelativeDate(date);
}
